var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-rc-date",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M896 416v-160c0-19.2-12.8-32-32-32h-160v32c0 19.2-12.8 32-32 32s-32-12.8-32-32v-32h-256v32c0 19.2-12.8 32-32 32s-32-12.8-32-32v-32h-160c-19.2 0-32 12.8-32 32v160h768z m0 64h-768v288c0 19.2 12.8 32 32 32h704c19.2 0 32-12.8 32-32v-288z m-192-320h160c54.4 0 96 41.6 96 96v512c0 54.4-41.6 96-96 96h-704c-54.4 0-96-41.6-96-96v-512c0-54.4 41.6-96 96-96h160v-32c0-19.2 12.8-32 32-32s32 12.8 32 32v32h256v-32c0-19.2 12.8-32 32-32s32 12.8 32 32v32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcDate);
export default __webpack_public_path__ + "static/media/rc-date.e04f9be5580ade14254f72f4fcaf36de.svg";
export { ForwardRef as ReactComponent };